<template>
  <div v-if="!getIsEmpty" class="floatingtoolbar" :style="styles" tabindex="-1">
    <floating-toolbar-button
      v-for="button in getButtons"
      :id="button.id"
      :key="button.id"
    />
    <div
      v-if="isSubmenuVisible"
      class="floatingtoolbarsubmenu"
      :style="submenuStyles"
    >
      <component :is="submenu.component" v-bind="submenu.props" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FloatingToolbarButton from './FloatingToolbarButton.vue';
import SubmenuLink from './SubmenuLink.vue';

export default {
  components: {
    'floating-toolbar-button': FloatingToolbarButton,
    'submenu-link': SubmenuLink,
  },
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  computed: {
    ...mapGetters('application/contextToolbar', [
      'getIsEmpty',
      'getButtons',
      'getAnchorRect',
      'getOpenSubmenu',
      'getSubmenu',
      'getSubmenuPosition',
    ]),

    styles() {
      const rect = this.getAnchorRect;
      if (rect != null) {
        // Center the toolbar horizontally above the anchor rect
        const left = rect.topLeft.x + (rect.width - this.width) / 2;
        let top = rect.topLeft.y - 60;
        // Adjust the position to fit the viewport
        if (top < 10) {
          top = rect.bottom + 20;
        }

        // If no room in bottom, put it on top
        const boardSectionHeight = document.querySelector(
          'div.sideandboard > div.main'
        ).clientHeight;

        if (boardSectionHeight - top < 60) {
          top = 20;
        }

        return { left: `${left}px`, top: `${top}px` };
      }
      return {};
    },
    submenuStyles() {
      let position = {};
      if (this.getOpenSubmenu) {
        position = this.getSubmenuPosition;
      }
      return { left: `${position.left}px`, top: `${position.top}px` };
    },
    isSubmenuVisible() {
      return this.getOpenSubmenu;
    },
    submenu() {
      if (this.getOpenSubmenu) {
        return this.getSubmenu(this.getOpenSubmenu);
      }
      return null;
    },
  },
  watch: {
    getButtons(newVal, oldVal) {
      // Auto-center the toolbar
      if (newVal.length > 0) {
        this.$nextTick(() => {
          const toolbarRect = this.$el.getBoundingClientRect();
          this.width = toolbarRect.width;
          this.height = toolbarRect.height;
        });
      } else {
        this.width = 0;
        this.height = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.floatingtoolbar {
  position: absolute;
  top: 10px;
  left: 10px;
  white-space: nowrap;
  background: #2c3233;
  box-shadow: 0px 8px 10px rgba(13, 14, 14, 0.25);
  border-radius: 4px;
  padding: 5px;
  z-index: 1000;
  transform: translateX(-50%);
}
.floatingtoolbarsubmenu {
  position: absolute;
  background: #2c3233;
  box-shadow: 0px 8px 10px rgba(13, 14, 14, 0.25);
  border-radius: 4px;
  padding: 8px 8px 8px 12px;
}
</style>
